import React, { useEffect, useRef } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import styles from './Winners.module.css'
import hum from '../../assets/images/hum.jpg'
import confetti from '../../assets/images/confetti.gif'
import classNames from 'classnames'
import { hideNumber } from '../../helpers/titreHelper'
import { useGetParams } from '../../hooks/useGetParams'

const Star = ({ className }) => (
  <svg
    className={classNames(styles.star, className)}
    version="1.1"
    id="Capa_1"
    // xmlns="http://www.w3.org/2000/svg"
    // xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    fill="#e7009e"
    viewBox="0 0 487.222 487.222"
    // style="enable-background:new 0 0 487.222 487.222;"
    // xml:space="preserve"
  >
    <g>
      <path d="M486.554,186.811c-1.6-4.9-5.8-8.4-10.9-9.2l-152-21.6l-68.4-137.5c-2.3-4.6-7-7.5-12.1-7.5l0,0c-5.1,0-9.8,2.9-12.1,7.6 l-67.5,137.9l-152,22.6c-5.1,0.8-9.3,4.3-10.9,9.2s-0.2,10.3,3.5,13.8l110.3,106.9l-25.5,151.4c-0.9,5.1,1.2,10.2,5.4,13.2 c2.3,1.7,5.1,2.6,7.9,2.6c2.2,0,4.3-0.5,6.3-1.6l135.7-71.9l136.1,71.1c2,1,4.1,1.5,6.2,1.5l0,0c7.4,0,13.5-6.1,13.5-13.5 c0-1.1-0.1-2.1-0.4-3.1l-26.3-150.5l109.6-107.5C486.854,197.111,488.154,191.711,486.554,186.811z M349.554,293.911 c-3.2,3.1-4.6,7.6-3.8,12l22.9,131.3l-118.2-61.7c-3.9-2.1-8.6-2-12.6,0l-117.8,62.4l22.1-131.5c0.7-4.4-0.7-8.8-3.9-11.9 l-95.6-92.8l131.9-19.6c4.4-0.7,8.2-3.4,10.1-7.4l58.6-119.7l59.4,119.4c2,4,5.8,6.7,10.2,7.4l132,18.8L349.554,293.911z" />
    </g>
  </svg>
)

export const Winners = ({ winnerMessages }) => {
  const { winnerTitleFontSize, winnerSize, winnerFontSize } = useGetParams()
  const confettiRef = useRef(null)

  const errorHandler = (e) => {
    e.target.src = hum
  }

  useEffect(() => {
    let idTimeout = ''
    if (confettiRef.current) {
      idTimeout = setTimeout(() => {
        confettiRef.current.style.display = 'block'
      }, 2500)
    }
    return () => {
      clearTimeout(idTimeout)
    }
  }, [confettiRef])

  return (
    <div className={styles.winnersContainer}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, ease: 'easeIn' }}
        className={styles.title}
      >
        <h1 style={{ fontSize: `${winnerTitleFontSize}rem` }}>
          {winnerMessages?.length > 1 ? 'Победители' : 'Победитель'}
        </h1>
      </motion.div>

      <div className={classNames(styles.starContainer, styles.star1Container)}>
        <Star className={classNames(styles.star1, 'dance')} />
      </div>
      <div className={classNames(styles.starContainer, styles.star2Container)}>
        <Star className={classNames(styles.star2, 'dance')} />
      </div>
      <div className={classNames(styles.starContainer, styles.star3Container)}>
        <Star className={classNames(styles.star3, 'dance')} />
      </div>
      <div className={classNames(styles.starContainer, styles.star4Container)}>
        <Star className={classNames(styles.star4, 'dance')} />
      </div>

      <div className={styles.winnersBlock}>
        <AnimatePresence>
          {winnerMessages &&
            winnerMessages.slice(0, 3).map((win, i) => {
              const [name, surname] = win.message?.author
                ?.trim()
                ?.split(' ')
                .map((s) => s?.trim())
              return (
                <motion.div
                  key={win.id}
                  initial={{ width: 0, opacity: 0, y: '100rem', scale: 0 }}
                  animate={{ width: 'auto', opacity: 1, y: 0, scale: 1 }}
                  exit={{ width: 0, opacity: 0, scale: 0 }}
                  transition={{ duration: 1, ease: 'easeOut' }}
                  className={styles.m}
                >
                  <div className={styles.winnerItem}>
                    <img
                      onError={errorHandler}
                      src={
                        (win.message?.image &&
                          win.message.image !== '1' &&
                          win.message.image) ||
                        hum
                      }
                      style={{
                        width: `${winnerSize}rem`,
                        height: `${winnerSize}rem`,
                      }}
                      alt="avatar"
                      className={styles.avatar}
                    />
                    <div
                      className={styles.name}
                      style={{ fontSize: `${winnerFontSize}rem` }}
                    >
                      {win.message?.author
                        ? `${name}${surname ? ` ${surname[0]}.` : ''}`
                        : hideNumber(win.message?.senderNumber)}
                    </div>
                  </div>
                </motion.div>
              )
            })}
        </AnimatePresence>
      </div>
      {/* <img className={styles.cup1} alt="cup1" src={cup} />
      <img className={styles.cup2} alt="cup2" src={cup} /> */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1.5, ease: 'easeIn' }}
        className={styles.confetti}
      >
        <img
          src={confetti}
          alt="confetti"
          className={styles.confetti}
          ref={confettiRef}
        />
      </motion.div>
    </div>
  )
}
